// -----------------------------------------------------------------------------
// Scripts for sticky header
// -----------------------------------------------------------------------------

function stickyHeader() {

  if ($(window).scrollTop() > 200) {
    $('.header').addClass('header--sticky');
  } else {
    $('.header').removeClass('header--sticky');
  }

}